import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

import ServiceAvailable from './ServiceAvailable';
import ServiceNotAvailable from './ServiceNotAvailable';
import { setTitle, setMetaDescription } from '../../util';
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import { AVAILABLE_PREWIRED, AVAILABLE_NOT_PREWIRED, COMING_SOON, NOT_AVAILABLE, UNAVAILABLE } from "../../data/status";

class CheckAvailability extends Component {
  constructor(props) {

    super(props);
    this.state = {
      serviceAvailable: null,
      animation: "fade left"
    };

    this.setServiceAvailable = this.setServiceAvailable.bind(this);
  }

  redirect() {
    const { history } = this.props;
    history.push("/");
  }

  setServiceAvailable(avail, animation) {

    this.redirect();

    // this.setState({
    //   serviceAvailable: avail,
    //   animation: animation
    // });
  }

  componentDidMount() {
    document.title = setTitle(this.props.title);
    setMetaDescription(this.props.description);
  }

  renderStep() {
    const { status } = this.props;
    const { animation } = this.state;

    switch (status) {
      case AVAILABLE_PREWIRED:
      case AVAILABLE_NOT_PREWIRED:
        return <ServiceAvailable setServiceAvailable={this.setServiceAvailable} animation={animation} />;
      case COMING_SOON:
      case NOT_AVAILABLE:
      case UNAVAILABLE:
        return <ServiceNotAvailable setServiceAvailable={this.setServiceAvailable} animation={animation} />;
      default:
        return <Redirect to='/?from=check-availability' preserveQueryString={false} />;
    }
  }

  render() {
    return (
      <Fragment>
        {this.renderStep()}
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    status: state.connection.status
  }
}

export default connect(mapStateToProps)(withRouter(CheckAvailability));


// WEBPACK FOOTER //
// ./src/components/check-availability/CheckAvailability.js